import React, { useState } from "react";
import "./CareersFAQ.css";

const CareersFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

const faqs = [
  {
    question: "How can I apply for a career at CM Green Energy India Pvt. Ltd.?",
    answer:
      "You can apply through our Careers section by submitting the online application form. You may also send your updated resume to careers@cmgreenenergy.com with the desired role mentioned in the subject line.",
  },
  {
    question: "What kind of roles are available?",
    answer:
      "We offer opportunities across renewable energy project development, solar and wind operations, engineering, site management, project coordination, sustainability research, and administrative support.",
  },
  {
    question: "Do you provide training for new employees?",
    answer:
      "Yes, we offer structured onboarding programs, technical training, and hands-on project exposure to help new employees build expertise in the renewable energy sector.",
  },
  {
    question: "Is prior experience in renewable energy required?",
    answer:
      "While relevant industry experience is preferred, we also welcome passionate freshers and professionals from related fields who are eager to learn and contribute.",
  },
  {
    question: "Does CM Green Energy offer career growth opportunities?",
    answer:
      "Absolutely. We are committed to nurturing talent and offer continuous growth opportunities through skill development programs, certifications, internal promotions, and leadership roles.",
  },
];



  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="careers-faq">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span>{faq.question}</span>
              <span className="faq-icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>
            <div
              className="faq-answer"
              style={{
                maxHeight: activeIndex === index ? "200px" : "0",
              }}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CareersFAQ;
